import { IReactionDisposer, observable, reaction } from 'mobx';
import { MarketStore } from '.';
import { AuthBase } from '../AuthBase';
import { SpotTradeRecord, TradeHistory } from '../canister/TradeHistory';
import { IDisposable } from '../interface';

export class TradeHistoryStore extends AuthBase implements IDisposable {
  @observable
  tradeHistoryList: Array<SpotTradeRecord> = [];
  private marketStore: MarketStore;
  private tradeHistoryActor: TradeHistory;
  private timer?: NodeJS.Timer = undefined;
  private fetchTimeInterval: number = 1000 * 10;
  private maxTradeHistoryCount = 100;
  private sessionSupervisorDisposer?: IReactionDisposer;

  constructor(marketStore: MarketStore) {
    super();
    this.marketStore = marketStore;
    const setting = marketStore.marketSetting;
    this.tradeHistoryActor = new TradeHistory(
      setting.tradeHistoryCanisterId,
      marketStore.baseToken.decimals,
      marketStore.quoteToken.decimals,
      setting.priceDecimals
    );
    this.sessionSupervisorDisposer = reaction(
      () => this.session.isConnected,
      async connected => {
        if (connected) {
          await this.updateUserTradeList();
          this.startFetchMyTradeHistoryTimer();
        } else {
          this.stopFetchMyTradeHistoryTimer();
          this.tradeHistoryList = [];
        }
      },
      { fireImmediately: true }
    );
  }

  public updateUserTradeList = async () => {
    this.tradeHistoryList = await this.tradeHistoryActor.fetchUserTradeList(
      0,
      this.maxTradeHistoryCount
    );
  };

  private startFetchMyTradeHistoryTimer = () => {
    this.timer = setInterval(() => {
      if (!this.session.isConnected) return;
      this.updateUserTradeList();
    }, this.fetchTimeInterval);
  };

  private stopFetchMyTradeHistoryTimer = () => {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = undefined;
    }
  };

  dispose = () => {
    this.stopFetchMyTradeHistoryTimer();
    if (this.sessionSupervisorDisposer) this.sessionSupervisorDisposer();
  };
}
